import { IBlock, ITextBlock } from 'common/builder/blocks/blockInterfaces'
import { FlowChartTextBlockBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartTextBlockBuilder'
import {
  ConverterRule,
  BlockConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import { FlowChartTextBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartTextBlock'
import { BlockType } from 'common/builder/constants/BlockType'
import { clearTextFromTags } from 'components/MCTextEditor/formatting/adapter'

export const TextBlockGenericConverterRule: ConverterRule<
  ITextBlock,
  FlowChartTextBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) => entity?.type === BlockType.TEXT,
  convert: (entity: ITextBlock, { fields, flowChartButtons }) =>
    new FlowChartTextBlockBuilder(entity.id)
      .withText(clearTextFromTags(replaceFieldsInString(entity.text, fields)))
      .withButtons(getButtonsFromMap(entity.buttons, flowChartButtons))
      .build(),
}
